import React, { Component } from "react";
import './ConversationStyleSheet.css';
import PreviewAttachmentFiles from "./PreviewAttachmentFiles";
import { debounce } from 'lodash';
import ActivityIndicator from "../CommonUtils/ActivityIndicator";

import Picker from 'emoji-picker-react'

class InputBox extends Component {

    constructor(props) {
        super(props);
        this.messageRef = React.createRef();
        this.file = React.createRef();
        this.state = { 
            previewFiles: [],
            isLoading:false,
            showEmoji:false
        }
    }

    defaultMessage = "Type a message..."

    render() {
        return (
            <>
                <div className="s360-conversation-input-box-container" style={{ height: "60px" }}>
                    <div className="s360-input-box-attachment" onClick={() => this.file.current.click()}>
                        <input style={{ opacity: "0", width: '1px', display: "none" }} ref={this.file} type="file" multiple="multiple" onChange={this.onFileSelect} className="UploadFile image_uploader" />
                        {this.attachmentSVGImage(this.props.config.designDetails.innerButtonSVGColor)}
                    </div>

                    <div className="s360-input-box-attachment" onClick={this.showEmoji}>   
                    {this.emojiSVGImage(this.props.config.designDetails.innerButtonSVGColor)}
                    </div>
                    <div>{this.state.showEmoji && <Picker onEmojiClick={this.onEmojiClick} groupVisibility={{flags: false,animals_nature:false,food_drink:false,travel_places:false,activities:false,objects:false,symbols:false}}
                            pickerStyle={{"position":"absolute","top":"-310px","left":"9px","width":"95%"}} />}</div>
                    <div className="s360-input-box-input-container" style={this.containerStyle()} >
                        {/* <input ref={this.messageRef}  className="s360-input-box-input"  placeHolder={this.defaultMessage} onBlur={this.onInputOut} onClick={this.onClickInput} type="text" onChange={this.onTextFieldChange}  style={this.containerStyle()} onKeyPress={this.handleKeyPress} /> */}
                        <input ref={this.messageRef}  className="s360-input-box-input"  placeHolder={this.defaultMessage}  type="text" onChange={this.onTextFieldChange}  style={this.containerStyle()} onKeyPress={this.handleKeyPress} />
                        <div className="s360-input-box-send" onClick={this.onMessageSend}>
                        {this.sendSVGImage(this.props.config.designDetails.innerButtonSVGColor)}
                    </div>
                    </div>
                </div>
                {(this.state.previewFiles.length > 0) && <PreviewAttachmentFiles {...this.props} {...this.state} onRemovePreviewFile={this.onRemovePreviewFile}  files={this.state.previewFiles} />}
            </>
        )
    }


    onEmojiClick = (event, emojiObject) => {
       const ref =  this.messageRef.current;
        ref.focus();
     
        const start = ref.value.substring(0,ref.selectionStart);
        const end = ref.value.substring(ref.selectionStart);
        const txt = start + emojiObject.emoji + end;
        ref.value = txt;
      }
 
    showEmoji = () =>
    {
        let chk = (this.state.showEmoji)?false:true
        this.setState({showEmoji: chk}); 
    }
    containerStyle = () => {
        return {
            borderColor:     this.props.config.designDetails.headerColor,
            color:           this.props.config.designDetails.headerColor,
            backgroundColor: this.props.config.designDetails.pageBackgroundColor
        }
    }

    onClickInput = (e) => {
        if (e.target.value === this.defaultMessage) { this.messageRef.current.value = ""; }
    }

    onInputOut = (e) => {
        if (!e.target.value || !e.target.value.trim) { this.messageRef.current.value = this.defaultMessage; }
    }

    currentTypingStatus = false;
    onTextFieldChange = () => {
        if (this.currentTypingStatus === false) {
            this.props.sendTypingStatus(true);
        }
        this.currentTypingStatus = true;
        this.debouncedTextChange();
    }

    debouncedTextChange = debounce(() => {
        if (this.currentTypingStatus === true) {
            this.props.sendTypingStatus(false);
        }
        this.currentTypingStatus = false;
    }, 1000)

    handleKeyPress = (event) => {
        if (event.key === 'Enter') {
            // console.log('enter press here! ')
            event.preventDefault();
            this.onMessageSend();
        }
    }

    // MARK: On Send Button Click.
    onMessageSend = () => {

       

        let isMediaAttached = (this.state.previewFiles || []).length !== 0;
        let hasTextMessage  = !(!this.messageRef.current.value || !this.messageRef.current.value.trim() || this.messageRef.current.value === this.defaultMessage);
        if (!isMediaAttached && !hasTextMessage) { return }
        if (hasTextMessage && !isMediaAttached) {
            this.props.sendMessage(this.messageRef.current.value.trim());
        } else if (isMediaAttached) {
            let textMessage = hasTextMessage ? this.messageRef.current.value.trim() : null;
            this.setState({ isLoading: true }, () => {
                this.props.sendMessageWithAttachemnts(this.state.previewFiles, textMessage)
                          .finally(() => { this.setState({ isLoading: false, previewFiles: [] }); });
            });
        }
        this.messageRef.current.value = "";
        this.setState({showEmoji: false}); 
    }

    //MARK: Attachments
    onFileSelect = (e) => {
        if (e.target.files) {
            const filesToUpload = [];
            let files = e.target.files;
            for (var i = 0; i < files.length; i++) { filesToUpload.push(files[i]); }
            if (filesToUpload.length === 0) { return }
            this.setState({ previewFiles: filesToUpload });
        }
    }

    attachmentSVGImage = (imageColor, width, height) => {
        // return <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
        //     // width={width || "100%"} height={height || "100%"}
        //     viewBox="0 0 172 172"
        //     style={{ fill: imageColor }}><g transform="translate(-17.2,-17.2) scale(1.2,1.2)"><g fill="none" fillRule="nonzero" stroke="none" strokeWidth="1" strokeLinecap="butt" strokeLinejoin="miter" strokeMiterlimit="10" strokeDasharray="" strokeDashoffset="0" fontFamily="none" fontWeight="none" fontSize="none" textAnchor="none" style={{ mixBlendMode: "normal" }}><path d="M0,172v-172h172v172z" fill="none"></path><g fill={imageColor}><path d="M61.2965,154.06183c-11.11908,0 -22.24175,-4.2355 -30.702,-12.71008c-16.84883,-16.8775 -15.90642,-45.39008 0.95675,-62.25325l50.61817,-50.61817c5.96267,-5.96267 13.7815,-9.97242 22.19875,-10.49558c9.67142,-0.602 18.86625,2.88817 25.64233,9.67142c6.78325,6.77967 10.27342,15.9745 9.67142,25.64233c-0.52317,8.41367 -4.5365,16.23608 -10.49558,22.19875l-49.708,49.708c-4.00617,4.00617 -9.20558,6.79042 -14.84575,7.28492c-6.95167,0.60917 -13.588,-1.82033 -18.44342,-6.67933c-4.859,-4.85542 -7.2885,-11.49175 -6.67933,-18.44342c0.4945,-5.64017 3.27875,-10.84317 7.28492,-14.84575l34.64725,-34.64367c0.69875,-0.69875 1.83467,-0.69875 2.53342,0l5.06683,5.06683c0.69875,0.69875 0.69875,1.83467 0,2.53342l-34.93033,34.93033c-1.85258,1.85258 -3.27158,4.17458 -3.73383,6.75458c-0.74533,4.14233 0.54108,8.17717 3.41492,11.051c4.66908,4.66908 12.80325,4.67625 17.48308,0l51.13775,-51.13775c4.24625,-4.257 6.58617,-9.90433 6.58617,-15.91358c0,-6.00925 -2.33992,-11.66017 -6.58975,-15.90642c-4.24983,-4.24625 -9.90075,-6.58975 -15.90642,-6.58975c-6.00567,0 -11.65658,2.33992 -15.90642,6.58975l-52.374,52.37042c-12.72083,12.72442 -12.72083,33.42533 0,46.14975c12.728,12.72083 33.42892,12.71725 46.14975,0l50.79733,-50.79733c0.69875,-0.69875 1.83467,-0.69875 2.53342,0l5.06683,5.06683c0.69875,0.69875 0.69875,1.83467 0,2.53342l-50.79733,50.79733c-8.45308,8.45667 -19.565,12.685 -30.67692,12.685z"></path></g></g></g></svg>
    
        return <svg  width="15px" height="16px" style={{ fill: imageColor }} focusable="false" aria-hidden="true" viewBox="0 0 16 18"><path d="M14.154 6.918l-.004.003.001-.004-3.287 3.286-.006-.005-3.574 3.574c-.016.017-.03.036-.048.053l-.05.047-.043.041v-.002c-1.167 1.07-2.692 1.331-3.823.2-1.13-1.13-.89-2.677.18-3.843l-.005-.004.074-.073.016-.018c.006-.005.012-.009.017-.016l6.053-6.053.761.76-6.053 6.054-.029.028v.001l-.005.004-.073.074c.011-.01.025-.018.035-.03-.688.75-.93 1.636-.21 2.356.72.72 1.583.456 2.333-.232l-.03.034.04-.042.01-.008.008-.009.033-.03.031-.034.01-.009.007-.009 5.004-5.003.005.006 1.858-1.859c1.223-1.218 1.51-2.913.291-4.132C12.462.806 10.414.74 9.195 1.958L2.248 8.905c.003 0 .006-.002.008-.004-1.625 1.667-1.542 4.43.103 6.074 1.646 1.646 4.474 1.795 6.141.17-.003.002-.004.008-.008.012l.047-.047 6.053-6.054.042-.042.743.78-.025.021.001.002-6.05 6.05-.002.002-.002.001-.046.046h-.002c-2.094 2.04-5.578 1.894-7.652-.18-2.049-2.049-2.15-5.407-.183-7.505l-.006-.005h-.002l.076-.078 6.943-6.944.003-.002.004-.005c1.641-1.64 4.367-1.574 6.008.066 1.64 1.642 1.353 4.014-.288 5.655z" fill-rule="evenodd"></path></svg>
    
    }


    emojiSVGImage = (imageColor, width, height) => {
        // return <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
        //     // width={width || "100%"} height={height || "100%"}
        //     viewBox="0 0 172 172"
        //     style={{ fill: imageColor }}><g transform="translate(-17.2,-17.2) scale(1.2,1.2)"><g fill="none" fillRule="nonzero" stroke="none" strokeWidth="1" strokeLinecap="butt" strokeLinejoin="miter" strokeMiterlimit="10" strokeDasharray="" strokeDashoffset="0" fontFamily="none" fontWeight="none" fontSize="none" textAnchor="none" style={{ mixBlendMode: "normal" }}><path d="M0,172v-172h172v172z" fill="none"></path><g fill={imageColor}><path d="M61.2965,154.06183c-11.11908,0 -22.24175,-4.2355 -30.702,-12.71008c-16.84883,-16.8775 -15.90642,-45.39008 0.95675,-62.25325l50.61817,-50.61817c5.96267,-5.96267 13.7815,-9.97242 22.19875,-10.49558c9.67142,-0.602 18.86625,2.88817 25.64233,9.67142c6.78325,6.77967 10.27342,15.9745 9.67142,25.64233c-0.52317,8.41367 -4.5365,16.23608 -10.49558,22.19875l-49.708,49.708c-4.00617,4.00617 -9.20558,6.79042 -14.84575,7.28492c-6.95167,0.60917 -13.588,-1.82033 -18.44342,-6.67933c-4.859,-4.85542 -7.2885,-11.49175 -6.67933,-18.44342c0.4945,-5.64017 3.27875,-10.84317 7.28492,-14.84575l34.64725,-34.64367c0.69875,-0.69875 1.83467,-0.69875 2.53342,0l5.06683,5.06683c0.69875,0.69875 0.69875,1.83467 0,2.53342l-34.93033,34.93033c-1.85258,1.85258 -3.27158,4.17458 -3.73383,6.75458c-0.74533,4.14233 0.54108,8.17717 3.41492,11.051c4.66908,4.66908 12.80325,4.67625 17.48308,0l51.13775,-51.13775c4.24625,-4.257 6.58617,-9.90433 6.58617,-15.91358c0,-6.00925 -2.33992,-11.66017 -6.58975,-15.90642c-4.24983,-4.24625 -9.90075,-6.58975 -15.90642,-6.58975c-6.00567,0 -11.65658,2.33992 -15.90642,6.58975l-52.374,52.37042c-12.72083,12.72442 -12.72083,33.42533 0,46.14975c12.728,12.72083 33.42892,12.71725 46.14975,0l50.79733,-50.79733c0.69875,-0.69875 1.83467,-0.69875 2.53342,0l5.06683,5.06683c0.69875,0.69875 0.69875,1.83467 0,2.53342l-50.79733,50.79733c-8.45308,8.45667 -19.565,12.685 -30.67692,12.685z"></path></g></g></g></svg>
    
        return <svg  width="15px" height="16px" style={{ fill: imageColor }} focusable="false" aria-hidden="true" viewBox="0 0 18 18"><path d="M9 0a9 9 0 1 1 0 18A9 9 0 0 1 9 0zm0 1C4.589 1 1 4.589 1 9s3.589 8 8 8 8-3.589 8-8-3.589-8-8-8zM5 6.999a1 1 0 1 1 2.002.004A1 1 0 0 1 5 6.999zm5.999 0a1.002 1.002 0 0 1 2.001 0 1 1 0 1 1-2.001 0zM8.959 13.5c-.086 0-.173-.002-.26-.007-2.44-.132-4.024-2.099-4.09-2.182l-.31-.392.781-.62.312.39c.014.017 1.382 1.703 3.37 1.806 1.306.072 2.61-.554 3.882-1.846l.351-.356.712.702-.35.356c-1.407 1.427-2.886 2.15-4.398 2.15z" fill-rule="evenodd"></path></svg>
    
    }

    sendSVGImage = (imageColor, width, height) => {
        // return <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
        //     // width={width || "100%"} height={height || "100%"}
        //     viewBox="0 0 172 172"
        //     style={{ fill: imageColor }}><g fill="none" fillRule="nonzero" stroke="none" strokeWidth="1" strokeLinecap="butt" strokeLinejoin="miter" strokeMiterlimit="10" strokeDasharray="" strokeDashoffset="0" fontFamily="none" fontWeight="none" fontSize="none" textAnchor="none" style={{ mixBlendMode: "normal" }}><path d="M0,172v-172h172v172z" fill="none"></path><g id="original-icon" fill={imageColor}><path d="M10.07813,10.16211l20.24024,65.08789h130.93164zM30.31836,86l-20.24024,65.0459l151.17188,-65.0459z"></path></g></g></svg>
        

        return <svg focusable="false" aria-hidden="true" x="0px" y="0px" viewBox="0 0 15 16" width="15px" height="16px" style={{ fill: imageColor }}><g transform="translate(-24.000000, -12.000000)"><path d="M25.4036262,27.3409362 C24.4176893,27.8509036 23.8195834,27.3951055 24.0683403,26.3201996 L25.0887779,21.910776 C25.2131242,21.3734618 25.7510472,20.8884231 26.3078778,20.8254187 L32.503417,20.1244045 C34.151155,19.9379658 34.1569707,19.6389088 32.503417,19.4549971 L26.3078778,18.7659164 C25.7589338,18.7048617 25.2129433,18.217839 25.0887779,17.6798715 L24.0683403,13.2586546 C23.8198614,12.1820783 24.408944,11.7182276 25.4036262,12.2327184 L38.22304,18.8634497 C39.208977,19.373417 39.2177223,20.1957141 38.22304,20.7102049 L25.4036262,27.3409362 Z"></path></g></svg>
    }

    onRemovePreviewFile = (file)  => {
        let previewFiles = this.state.previewFiles || [];
        previewFiles = previewFiles.filter(previewFile => previewFile.name !== file.name);
        this.setState({previewFiles: previewFiles});
    }

}

export default InputBox;